import React from 'react'
import LazeCuttingErrorHeader from './LazeCuttingErrorTable/LazeCuttingErrorHeader'
import LazeCuttingErrorRow from './LazeCuttingErrorTable/LazeCuttingErrorRow'

function LazeCuttingErrorTable(props) {
    const { listLaze, loading, setType } = props

    return (
        <div className='LazeCuttingErrorTable'>
            <table className="table table-borderless table-striped">
                <LazeCuttingErrorHeader />
                <tbody className="LazeCuttingErrorRow">
                    {
                        !!listLaze && listLaze.length > 0 && listLaze.map((item, i) => {
                            return <LazeCuttingErrorRow
                                key={i}
                                index={i}
                                item={item}
                                setType={setType}
                            />
                        })
                    }
                    {
                        !loading && (!listLaze || listLaze.length === 0) &&
                        <tr>
                            <td colSpan={9}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default LazeCuttingErrorTable